/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Addons_TitleInputs */

const tr_pricing_addons_title = /** @type {(inputs: Pricing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek kredi paketi talep edin`)
};

const en_pricing_addons_title = /** @type {(inputs: Pricing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request an extra credit pack`)
};

const de_pricing_addons_title = /** @type {(inputs: Pricing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliches Credit-Paket anfragen`)
};

const ru_pricing_addons_title = /** @type {(inputs: Pricing_Addons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросите дополнительный пакет кредитов`)
};

/**
* | output |
* | --- |
* | "Request an extra credit pack" |
*
* @param {Pricing_Addons_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_addons_title = /** @type {((inputs?: Pricing_Addons_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Addons_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_addons_title(inputs)
	if (locale === "de") return de_pricing_addons_title(inputs)
	if (locale === "ru") return ru_pricing_addons_title(inputs)
	return tr_pricing_addons_title(inputs)
});